<template>
  <div
    class="n-image-message"
    :class="{
      'n-image-message--left': tooltipPosition === 'right',
      'n-image-message--right': tooltipPosition === 'left',
    }"
  >
    <n-avatar
      size="s"
      :name="message.name"
      :imageUrl="message.avatarUrl"
      v-if="displayAvatar"
      :enableTooltip="enableAvatarTooltip"
      class="n-image-message__avatar"
      :class="{
        'n-image-message__avatar--left': tooltipPosition === 'right',
        'n-image-message__avatar--right': tooltipPosition === 'left',
      }"
    ></n-avatar>
    <n-tooltip :position="tooltipPosition">
      <template #default>
        <img :src="message.mediaSrc" :alt="message.altText" class="n-image-message__image" />
      </template>
      <template #message>
        <span>
          {{ getMessageTimestamp(message.timestampUtc) }}
          <n-icon icon="alert" fill="#ff6348" v-if="shouldShowAlertIcon(message)" />
          <n-icon
            icon="tick"
            :fill="isRead(message) ? '#57d272' : '#bdbdbd'"
            v-if="shouldShowTickIcon(message)"
          ></n-icon>
        </span>
      </template>
    </n-tooltip>
  </div>
</template>

<script lang="ts" setup>
import NIcon from '../../brand/icon/icon.vue';
import NTooltip from '../../control/tooltip/tooltip.vue';
import NAvatar from '../avatar/avatar.vue';
import { ImageMessage, Message } from './message';
import { MessageStatus } from './messageStatus';
import { PropType } from 'vue';
import moment from 'moment';

defineProps({
  message: {
    type: Object as PropType<ImageMessage>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPosition: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
});

function getMessageTimestamp(timestamp: Date): string {
  return moment(timestamp).format('HH:mm');
}

function shouldShowAlertIcon(m: Message) {
  return m.status === MessageStatus.DeliveryFailed;
}

function isRead(m: Message) {
  return m.status === MessageStatus.Read;
}

function shouldShowTickIcon(m: Message) {
  switch (m.status) {
    case MessageStatus.DeliverySucceeded:
    case MessageStatus.Read:
    case MessageStatus.Received:
    case MessageStatus.Sent:
      return true;
    default:
      return false;
  }
}
</script>

<style lang="scss" scoped>
.n-image-message {
  padding: 0 0.5em;
  max-width: 392px;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  &__image {
    display: block;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0.2em;
  }
  &--right {
    flex-direction: row-reverse;
  }
  &__avatar {
    flex: 0 0 auto;
    &--left {
      margin-right: 0.5rem;
    }
    &--right {
      margin-left: 0.5rem;
    }
  }
}
</style>
